/* ==========================================================================
   SMELLERS · Landing 2 — "No perfuma: elimina"
   CTA único: agrega 1 Cazaorina y manda al carrito. Sin selectores ni
   variantes que distraigan (público frío).
   ========================================================================== */
(function () {
  'use strict';

  var page = document.querySelector('[data-el-page]');
  if (!page) return;

  var dock = document.querySelector('[data-el-dock]');
  var buyBox = document.getElementById('el-comprar');
  var busy = false;

  function root() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  function add(btn) {
    if (busy) return;
    var id = parseInt(btn.dataset.variant, 10);
    if (!id) return;
    busy = true;
    btn.setAttribute('aria-busy', 'true');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status && data.status !== 200) throw new Error(data.description || 'Error');
        window.location.href = root() + 'cart';
      })
      .catch(function () {
        busy = false;
        btn.removeAttribute('aria-busy');
        var err = document.querySelector('[data-el-error]');
        if (err) {
          err.hidden = false;
          err.textContent = 'No pudimos agregarlo. Intenta de nuevo o escríbenos por WhatsApp.';
        }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-el-add]');
    if (btn) add(btn);
  });

  /* La barra sticky sale al pasar el hero y se esconde cuando el buy box ya
     está a la vista: no tiene caso repetir el mismo botón dos veces. */
  if (dock && 'IntersectionObserver' in window) {
    var pastHero = false;
    var buyVisible = false;

    function sync() {
      var show = pastHero && !buyVisible;
      dock.classList.toggle('is-up', show);
      page.classList.toggle('el--dock-on', show);
    }

    var hero = document.querySelector('.el__hero');
    if (hero) {
      new IntersectionObserver(function (en) {
        pastHero = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sync();
      }, { threshold: 0 }).observe(hero);
    }

    if (buyBox) {
      new IntersectionObserver(function (en) {
        buyVisible = en[0].isIntersecting;
        sync();
      }, { threshold: 0.12 }).observe(buyBox);
    }
  }
})();

/* --- galería de la ficha de producto --- */
(function () {
  'use strict';
  var main = document.querySelector('[data-el-main]');
  if (!main) return;
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-el-thumb]');
    if (!t) return;
    main.src = t.dataset.full;
    document.querySelectorAll('[data-el-thumb]').forEach(function (b) {
      b.classList.toggle('is-on', b === t);
    });
  });
})();

/* --- selector de producto de la ficha --- */
(function () {
  'use strict';
  var picks = document.querySelectorAll('[data-el-pick]');
  if (!picks.length) return;

  var name = document.querySelector('[data-el-pname]');
  var price = document.querySelector('[data-el-pprice]');
  var size = document.querySelector('[data-el-psize]');
  var content = document.querySelector('[data-el-pcontent]');
  var yield_ = document.querySelector('[data-el-pyield]');
  var main = document.querySelector('[data-el-main]');
  var btn = document.querySelector('[data-el-pbtn]');
  var thumbs = document.querySelector('.el__pdp-thumbs');

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-el-pick]');
    if (!t) return;
    var d = t.dataset;

    picks.forEach(function (b) { b.classList.toggle('is-on', b === t); });
    if (name) name.textContent = d.name;
    if (size) size.textContent = d.size;
    if (content) content.textContent = d.size === '946 ml' ? '946 ml (32 oz)' : d.size;
    /* el rendimiento cambia por producto: el concentrado no se usa igual */
    if (yield_ && d.yield) yield_.textContent = d.yield;
    if (price) price.firstChild.nodeValue = d.price;
    if (main) main.src = d.img;
    if (btn) btn.dataset.variant = d.variant;

    /* las miniaturas son de Cazaorina: solo tienen sentido con ese producto */
    if (thumbs) thumbs.hidden = d.size !== '946 ml';
  });
})();
